import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "space-y-4" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "home-container rounded-lg z-1 p-0 md:-m-5 md:mx-auto" }
const _hoisted_4 = { class: "bigtitle" }
const _hoisted_5 = { class: "w-full h-full grid grid-cols-3 sm:grid-cols-6 gap-8 gap-y-10 p-2" }
const _hoisted_6 = { class: "text-lg font-black text-gray-600 wow animate__animated animate__slideInDown" }
const _hoisted_7 = { class: "text-base text-center text-gray-600 wow animate__animated animate__slideInDown" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("去查看")
const _hoisted_9 = { class: "w-full wow animate__animated animate__slideInUp bg-white mt-10 mb-20" }
const _hoisted_10 = { class: "home-container product" }
const _hoisted_11 = { class: "product-l" }
const _hoisted_12 = { class: "name" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "center-wrap" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "center-desc" }, "CENTER"),
  /*#__PURE__*/_createElementVNode("span", { class: "product-center" }, "产品中心")
], -1)
const _hoisted_14 = { class: "pro-desc" }
const _hoisted_15 = { class: "product-r" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_avatar = _resolveComponent("n-avatar")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_jc_prod_car = _resolveComponent("jc-prod-car")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        class: "w-full wow animate__aanimated animate__flipInX",
        src: _ctx.imgUrl
      }, null, 8, _hoisted_2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.myFw), 1),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sliders, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "flex justify-around items-center space-y-4 flex-col cursor-pointer"
          }, [
            _createVNode(_component_n_avatar, {
              size: 100,
              src: require('../../assets/icons/sliderIcon' + (index + 1) + '.png'),
              class: _normalizeClass(['bg-transparent wow animate__animated', 'animate__rollIn']),
              round: ""
            }, null, 8, ["src"]),
            _createElementVNode("div", _hoisted_6, _toDisplayString(item.message), 1),
            _createElementVNode("div", _hoisted_7, _toDisplayString(item.brief), 1),
            _createElementVNode("div", null, [
              _createVNode(_component_router_link, {
                class: "goCheck",
                to: item.link,
                style: _normalizeStyle({ visibility: item.isVisibility ? 'visible' : 'hidden' })
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 2
              }, 1032, ["to", "style"])
            ])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.prodCenter), 1),
          _hoisted_13,
          _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.prodMsg), 1)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_jc_prod_car, {
            title: _ctx.prods.kxh.title,
            msg: _ctx.prods.kxh.msg,
            topath: "/kaixinhu",
            imgsrc: require('../../assets/prod-kxh.png'),
            class: "space-y-1"
          }, null, 8, ["title", "msg", "imgsrc"]),
          _createVNode(_component_jc_prod_car, {
            title: _ctx.prods.ybd.title,
            msg: _ctx.prods.ybd.msg,
            topath: "/yibeiduo",
            imgsrc: require('../../assets/prod-ybd.png')
          }, null, 8, ["title", "msg", "imgsrc"]),
          _createVNode(_component_jc_prod_car, {
            title: _ctx.prods.msyx.title,
            msg: _ctx.prods.msyx.msg,
            topath: "/meishiyouxiang",
            imgsrc: require('../../assets/prod-msyx.png')
          }, null, 8, ["title", "msg", "imgsrc"]),
          _createVNode(_component_jc_prod_car, {
            title: _ctx.prods.kxhgcd.title,
            msg: _ctx.prods.kxhgcd.msg,
            topath: "/kaixinhugongchangduan",
            imgsrc: require('../../assets/prod-kxhgcd.png')
          }, null, 8, ["title", "msg", "imgsrc"])
        ])
      ])
    ])
  ]))
}